import React from 'react';
const ResponsiveLayoutContext = React.createContext();

export default ResponsiveLayoutContext;
